var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleClientIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499023 13.2729H9.45967M9.45967 13.2729V5.46484C10.0325 5.66187 11.3825 6.00196 12.0251 6.28283C12.6871 6.57215 12.8803 7.38815 12.8803 8.16055V13.2729M9.45967 13.2729H12.8803M13.6396 13.2729H12.8803",
    stroke: "#534BDB",
    strokeWidth: 0.998137,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12598 12.809V3.49862C1.12598 1.89265 1.12598 1.08902 1.63208 0.690404C2.13819 0.291786 2.88359 0.508687 4.37504 0.941215L7.57422 1.86961C8.47379 2.13066 8.92362 2.2612 9.18336 2.61758C9.4438 2.97332 9.44381 3.45768 9.44381 4.42766V12.809",
    stroke: "#534BDB",
    strokeWidth: 0.959748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3244 4.95312H6.2439M4.3244 7.51242H6.2439M6.88372 13.1898V11.3515C6.88372 10.748 6.88372 10.4467 6.69625 10.2592C6.50878 10.0717 6.20742 10.0717 5.60406 10.0717H4.96423C4.36086 10.0717 4.05951 10.0717 3.87204 10.2592C3.68457 10.4467 3.68457 10.748 3.68457 11.3515V13.2094",
    stroke: "#534BDB",
    strokeWidth: 0.959748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleClientIcon);
export default __webpack_public_path__ + "static/media/purple-client-icon.1d62747b7464b351d0488bc39b6aeb95.svg";
export { ForwardRef as ReactComponent };